import RichText from '@eneco/components/RichText/RichText';
import { Button, Grid, Heading, InputUsage, Stack } from '@eneco/sparky';
import { useTracking } from '@eneco/tracking';
import { useContent } from '@sitecore/common';
import { PriceSimulationRenderingExtended } from '@sitecore/types/manual/be/PriceSimulationExtended';
import { useFormContext } from 'react-hook-form';

import { PriceSimulationFormSchema } from '../schemas/priceSimulationFormSchema';
import { FlowChildProps } from '../types/PriceSimulationSteps';
import { getTrackableFormValues } from '../utils/getTrackableFormValues';

export const GasConsumptionStep = ({ nextMainStep }: FlowChildProps) => {
  const { fields } = useContent<PriceSimulationRenderingExtended>();
  const {
    register,
    trigger,
    formState: { errors },
    getValues,
  } = useFormContext<PriceSimulationFormSchema>();
  const { trackEventBE } = useTracking();

  const onNextClick = async () => {
    const isValid = await trigger('gasConsumption');
    if (!isValid) {
      return;
    }
    trackEventBE('pbt_calculation_gas_cons', {
      status: 'click',
      data: getTrackableFormValues(getValues()),
    });
    nextMainStep();
  };

  return (
    <>
      <Stack direction="column" gap="2">
        <Heading as="h1" size="M">
          {fields.gasConsumptionStep.title.value}
        </Heading>
        <div>
          <RichText html={fields.gasConsumptionStep.subTitle.value} />
        </div>
      </Stack>
      <Grid.Item alignSelf="stretch">
        <InputUsage
          {...register('gasConsumption')}
          label={fields.gasConsumptionStep.gasConsumptionFormField.value.label}
          placeholder={fields.gasConsumptionStep.gasConsumptionFormField.value.placeholder}
          hint={fields.gasConsumptionStep.gasConsumptionFormField.value.hint}
          type="gas"
          unit="kWh"
          {...(errors.gasConsumption && { error: errors.gasConsumption.message })}
        />
      </Grid.Item>
      <div>
        <RichText html={fields.gasConsumptionStep.description.value} />
      </div>
      <Button onClick={onNextClick}>{fields.navigation.nextButtonText.value}</Button>
    </>
  );
};
